"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassConfiguratorModule = /** @class */ (function () {
    function ClassConfiguratorModule() {
    }
    return ClassConfiguratorModule;
}());
exports.ClassConfiguratorModule = ClassConfiguratorModule;
